import { render, staticRenderFns } from "./MBtnCardComp.vue?vue&type=template&id=0511fbf3&"
import script from "./MBtnCardComp.vue?vue&type=script&lang=js&"
export * from "./MBtnCardComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports